export default __webpack_public_path__ + "static/media/Rectangle_29.66d79c03.png";